// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"604":"db28bdae","948":"58e7bbfe"}[chunkId] + ".chunk.js";
};